import u from "./ui.module.css";

/** Пилюля-фильтр (как в мобильных формах подбора). */
export function Chip({
  selected,
  onClick,
  children,
  count,
  className = "",
  type = "button",
}) {
  return (
    <button
      type={type}
      className={`${u.chip} ${selected ? u.chipSelected : ""} ${className}`.trim()}
      onClick={onClick}
      aria-pressed={selected}
    >
      <span className={u.chipInner}>
        {children}
        {count != null ? <span className={u.chipCount}>{count}</span> : null}
      </span>
    </button>
  );
}

export function ChipGroup({ children, className = "", label }) {
  return (
    <div className={`${u.chipGroup} ${className}`.trim()} role="group" aria-label={label}>
      {children}
    </div>
  );
}

/** Двухпозиционный переключатель (Продажа / Аренда). */
export function Segment({ options, value, onChange, className = "" }) {
  return (
    <div className={`${u.segment} ${className}`.trim()} role="tablist">
      {options.map((opt) => {
        const selected = value === opt.id;
        return (
          <button
            key={opt.id}
            type="button"
            role="tab"
            aria-selected={selected}
            className={selected ? u.segmentBtnOn : u.segmentBtn}
            onClick={() => onChange(opt.id)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
